<template>
  <div class="d-flex align-items-center justify-content-end">
    <small class="mr-2">
      <div class="text-truncate proyecto">{{ cliente }}</div>
      <div class="text-truncate proyecto font-weight-bold">{{ proyecto }}</div>
    </small>
    <span class="text-nowrap text-muted">
      (<span ref="suma" :class="{ 'text-danger': horasSuperadas }" title="Hores totals programades" v-tooltip>{{ totalFila ? totalFila : "0" }}</span>/<span ref="total" title="Hores disponibles" v-tooltip>{{ totalProyecto != null ? totalProyecto : "?" }}</span>)
    </span>
  </div>
</template>
  
<script>
export default {
  name: "celda-proyecto",
  props: ["proyecto", "cliente", "totalProyecto", "totalFila"],
  computed: {
    horasSuperadas() {
      return this.totalProyecto != null && (this.totalFila > 0 && (this.totalProyecto < 1 || this.totalFila > this.totalProyecto));
    },
  },
  beforeDestroy() {
    $(this.$refs.total).tooltip("dispose");
    $(this.$refs.suma).tooltip("dispose");
  }
};
</script>

<style lang="scss" scoped>
.proyecto {
  max-width: 40vw;
}

@media (min-width: 576px) {
  .proyecto {
    max-width: none;
  }
}
</style>